import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Separator from "app/pages/.shared/Separator";
import { htmlSanitize } from "app/utils/sanitize";
import { WarningStrokeIcon } from "app/icons/navigation";

const InsuranceContentNoInsurance = ({ insurance }) => {
	return (
		<div className="insurances__free">
			<Separator />

			<header className="insurances__no-header">
				<FormattedMessage id="payment.no.insurance.header.label" />
			</header>

			<section className="insurances__details">
				<div className="insurances__details-no-insurance">
					<div dangerouslySetInnerHTML={{ __html: htmlSanitize(insurance?.details) }} />
					<div>
						<WarningStrokeIcon />
					</div>
				</div>
			</section>
		</div>
	);
};

InsuranceContentNoInsurance.propTypes = {
	insurance: PropTypes.object.isRequired,
};

export default InsuranceContentNoInsurance;
